import dateTime from "./dateTime";

export default function differenceInYears(dateLeft: Date, dateRight: Date) {
  return dateTime(dateLeft).difference(dateRight, "years");
}
